import { FC, useMemo } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { useForm } from '@/forms/hooks/use-form';
import {
  buildSendAnnouncementFormSchema,
  SendAnnouncementFieldValues,
} from '@/forms/schemas/send-announcement/schema';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';

export type SendAnnouncementFormProps = {
  onCancel: () => void;
  onSubmit: (values: SendAnnouncementFieldValues) => void;
};

export const SendAnnouncementForm: FC<SendAnnouncementFormProps> = ({
  onCancel,
  onSubmit,
}) => {
  const formSchema = useMemo(() => buildSendAnnouncementFormSchema(), []);

  const { fieldItems, handleSubmit } = useForm({
    schema: formSchema,
    onSubmit,
  });

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          {strings.devices.drawer_announce.cancel}
        </Button>,
        <SubmitButton
          key="submit"
          text={strings.devices.drawer_announce.submit}
        />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
